module.exports = __webpack_public_path__ + "static/media/gap-insurance.f47de93a.png";